export enum EInviteChannel {
  EMAIL = "EMAIL",
  MOBILE = "MOBILE",
}
